export default __webpack_public_path__ + "static/media/office.5e9d064d.svg";